// extracted by mini-css-extract-plugin
module.exports = {"preview":"GenericIndicatorDetails_preview_5SITx","partials":"GenericIndicatorDetails_partials_3TW23","result":"GenericIndicatorDetails_result_mrG80"};